// extracted by mini-css-extract-plugin
export default {"avatar_collection":"AvatarCollection_avatar_collection__1O7xF","avatar":"AvatarCollection_avatar__fJksj"};